/**
 * @file Who started this browser's Gear session: 'self' (the person's own
 * Google sign-in) or 'hub' (the IT Hub signed them in). The hub may only end
 * sessions it started; audit entries from a hub session say `via: 'hub'`.
 * Same key in every STRV tool (playbook §6).
 */

const KEY = 'strv-session-origin';

export function setSessionOrigin(origin) {
  try {
    if (origin) localStorage.setItem(KEY, origin);
    else localStorage.removeItem(KEY);
  } catch { /* storage blocked: treated as the person's own session */ }
}

export function sessionOrigin() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
